<template>
    <div>
        <template v-if="tasks">
            <strong>Тип подзадачи:</strong>
            <Select
                name="subtaskType"
                :items="tasks"
                :active="active"
                @selectChange="v => $emit('typeChange', v)"
            />
        </template>
        <div v-else>Не созданы типы подзадач в настройках проекта</div>
    </div>
</template>

<script>
export default {
    name: "SubtaskType",
    props: [
        'tasks',
        'active',
    ],
}
</script>